import { render, staticRenderFns } from "./RequestPayloadTab.vue?vue&type=template&id=6797c3b9&scoped=true"
import script from "./RequestPayloadTab.vue?vue&type=script&lang=js"
export * from "./RequestPayloadTab.vue?vue&type=script&lang=js"
import style0 from "./RequestPayloadTab.vue?vue&type=style&index=0&id=6797c3b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797c3b9",
  null
  
)

export default component.exports